import { Box } from "@mui/material";
import { TimelineIcon } from "Components/Shared/VerticalTimeline/TimelineIcon";
import { TimelineConnector } from "Components/Shared/VerticalTimeline/TimelineConnector";
import { TimelineStepContent } from "Components/Shared/VerticalTimeline/TimelineStepContent";
import type { TimelineStep } from "Components/Shared/VerticalTimeline/types";

const MIN_ENTRY_HEIGHT = 80;
const STEP_SPACING = 5;

type Props = {
  step: TimelineStep;
  isLastStep: boolean;
  inactiveColor?: string;
};

export const TimelineStepItem = ({
  step: { icon, isCompleted, title, description },
  isLastStep,
  inactiveColor,
}: Props) => (
  <Box
    display="flex"
    position="relative"
    minHeight={MIN_ENTRY_HEIGHT}
    mb={isLastStep ? 0 : STEP_SPACING}
  >
    <Box
      mr={3}
      display="flex"
      alignItems="center"
      flexDirection="column"
      position="relative"
      alignSelf="flex-start"
      minHeight={MIN_ENTRY_HEIGHT}
    >
      <TimelineIcon
        icon={icon}
        isCompleted={isCompleted}
        inactiveColor={inactiveColor}
      />
    </Box>
    {!isLastStep && <TimelineConnector stepSpacing={STEP_SPACING} />}
    <TimelineStepContent title={title} description={description} />
  </Box>
);
